import * as singleSpa from 'single-spa';

import { traceAction, TraceActionRecord } from 'lib/util/tracing/routing-tracer'

let traceActionRecord = new TraceActionRecord('single-spa-completed-routing');

window.addEventListener('single-spa:before-routing-event', () => {
  traceActionRecord = new TraceActionRecord('single-spa-completed-routing');
  traceActionRecord.recordBefore();
})

window.addEventListener('single-spa:routing-event', () => {
  traceActionRecord.recordCompleted();
  traceActionRecord.gamma = singleSpa.getAppStatus('gamma') === 'MOUNTED'

  traceAction(traceActionRecord);
})

window.addEventListener('single-spa:app-change', () => {
  traceActionRecord.appChange = true;
})

window.addEventListener('single-spa:no-app-change', () => {
  traceActionRecord.appChange = false;
})

window.addEventListener('single-spa:before-first-mount', () => {
  traceActionRecord.firstMount = true;
});


// WEBPACK FOOTER //
// ./app/scripts/init/single-spa-events.js